import * as contract from '@tableau/hybrid-widgets-contract';

export class GlobalPositionAPIImpl implements contract.GlobalPositionAPI {
  public GetGlobalPositionCoordinates(position: contract.Point): Promise<contract.Point> {
    let pos: contract.Point = position;
    return Promise.resolve(pos);
  }
}

export const PositionAPIInstance: GlobalPositionAPIImpl = new GlobalPositionAPIImpl();
